/**
 * Citation Click Tracking
 *
 * Fire-and-forget tracking of citation clicks via PostHog for RAG quality analytics.
 * Failures are silently ignored to avoid impacting user experience.
 */

import { captureEvent } from '@/lib/posthog'

interface CitationClickData {
  sessionId?: string
  documentId: string
  documentName: string
  citationIndex: number
  pageNumber?: number | null
  confidenceBand?: 'high' | 'medium' | 'low' | null
  context: 'chat' | 'tender_chat' | 'drafting' | 'source_list'
}

/**
 * Track a citation click. Fire-and-forget — errors are silently ignored.
 */
export function trackCitationClick(data: CitationClickData): void {
  captureEvent('citation_clicked', {
    sessionId: data.sessionId,
    documentId: data.documentId,
    documentName: data.documentName,
    citationIndex: data.citationIndex,
    pageNumber: data.pageNumber ?? null,
    confidenceBand: data.confidenceBand ?? null,
    context: data.context,
  })
}
